import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {PhotoLieu} from '../models/photoLieu.model';
import {WorkOrder} from '../models/workOrder.model';
import {join} from 'lodash-es';

@Injectable({
    providedIn: 'root'
})
export class FicheInterventionService {
    private API_URL = environment.API_URL;
    private MODEL_URL = 'fiches-interventions';

    constructor(private http: HttpClient) {
    }

    getAllFichesInterventions(includes: string[] = []): Observable<FicheIntervention[]> {
        let params = new HttpParams();
        params = params.append('includes', join(includes));
        return this.http.get<FicheIntervention[]>(this.API_URL + this.MODEL_URL, {
            params
        });
    }

    getFichesInterventions(dossier_intervention_id: number): Observable<FicheIntervention[]> {
        return this.http.get<FicheIntervention[]>(this.API_URL + 'dossiers-interventions/' + dossier_intervention_id + '/' + this.MODEL_URL);
    }

    getFicheIntervention(id: number): Observable<FicheIntervention> {
        return this.http.get<FicheIntervention>(this.API_URL + this.MODEL_URL + '/' + id).pipe(
            catchError(err => throwError(err))
        );
    }

    getPhotos(id: number): Observable<PhotoLieu[]> {
        return this.http.get<PhotoLieu[]>(this.API_URL + this.MODEL_URL + '/' + id + '/photos').pipe(
            catchError(err => throwError(err))
        );
    }

    store(ficheIntervention: FicheIntervention): Observable<FicheIntervention> {
        return this.http.post<FicheIntervention>(this.API_URL + 'dossiers-interventions/' + ficheIntervention.dossier_intervention_id + '/' + this.MODEL_URL, ficheIntervention).pipe(
            catchError(err => throwError(err))
        );
    }

    update(ficheIntervention: FicheIntervention, id: number): Observable<FicheIntervention> {
        return this.http.put<FicheIntervention>(
            this.API_URL + this.MODEL_URL + '/' + id, ficheIntervention
        ).pipe(
            catchError(err => throwError(err))
        );
    }

    delete(id: number): Observable<any> {
        return this.http.delete(this.API_URL + this.MODEL_URL + '/' + id).pipe(
            catchError(err => throwError(err))
        );
    }

    storeOrUpdateWorkOrder(workOrder: WorkOrder): Observable<WorkOrder> {
        if (workOrder.id) {
            return this.http.put<WorkOrder>(
                this.API_URL + this.MODEL_URL + '/' + workOrder.fiche_intervention_id + '/work-orders/' + workOrder.id, workOrder
            ).pipe(
                catchError(err => throwError(err))
            );
        } else {
            return this.http.post<WorkOrder>(
                this.API_URL + this.MODEL_URL + '/' + workOrder.fiche_intervention_id + '/work-orders', workOrder
            ).pipe(
                catchError(err => throwError(err))
            );
        }
    }
}
